import { GpxPoint } from '../types';

const EARTH_RADIUS_M = 6371000;
const TO_RAD = Math.PI / 180;

export function haversine(
    a: { lat: number; lon: number },
    b: { lat: number; lon: number }
): number {
    const dLat = (b.lat - a.lat) * TO_RAD;
    const dLon = (b.lon - a.lon) * TO_RAD;
    const la1 = a.lat * TO_RAD;
    const la2 = b.lat * TO_RAD;
    const x =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(la1) * Math.cos(la2) * Math.sin(dLon / 2) ** 2;
    return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(x));
}

export function enrichTrack(points: GpxPoint[]): GpxPoint[] {
    let cumDist = 0;
    for (let i = 0; i < points.length; i++) {
        const p = points[i];
        if (i === 0) {
            p.dt = 0;
            p.segDist = 0;
            p.cumDist = 0;
            p.computedSpeed = p.speed;
            p.acceleration = null;
            p.headingDelta = null;
            p.yawRate = null;
            continue;
        }

        const prev = points[i - 1];
        p.dt = p.t !== null && prev.t !== null ? (p.t - prev.t) / 1000 : null;
        p.segDist = haversine(prev, p);
        cumDist += p.segDist;
        p.cumDist = cumDist;
        p.computedSpeed = p.dt !== null && p.dt > 0 ? p.segDist / p.dt : null;

        const s1 = p.speed !== null ? p.speed : p.computedSpeed;
        const s0 = prev.speed !== null ? prev.speed : prev.computedSpeed;
        p.acceleration =
            s1 !== null && s0 !== null && p.dt !== null && p.dt > 0
                ? (s1 - s0) / p.dt
                : null;

        if (p.heading !== null && prev.heading !== null) {
            let d = p.heading - prev.heading;
            while (d > 180) d -= 360;
            while (d < -180) d += 360;
            p.headingDelta = d;
            p.yawRate = p.dt !== null && p.dt > 0 ? d / p.dt : null;
        } else {
            p.headingDelta = null;
            p.yawRate = null;
        }
    }
    return points;
}
